import { cn } from '@/lib/utils';
import { Textarea as Root } from 'ui/textarea';
import { useFormField } from '.';
import { FormField } from './Field';
import { UseFormFieldProps } from './type';

interface Props extends UseFormFieldProps, React.ComponentProps<typeof Root> {
  name: string;
}

const Textarea = (props: Props) => {
  const { formFieldProps, childProps, error } = useFormField(props);

  const {
    placeholder,
    rows,
    cols,
    disabled,
    readOnly,
    maxLength,
    minLength,

    ...rest
  } = props;

  return (
    <FormField {...formFieldProps}>
      <Root
        {...rest}
        {...childProps}
        placeholder={placeholder}
        rows={rows}
        cols={cols}
        disabled={disabled}
        readOnly={readOnly}
        maxLength={maxLength}
        minLength={minLength}
        data-test={childProps.id}
        aria-invalid={!!error}
        className={cn(childProps.className, error && ' border-destructive focus-visible:ring-destructive')}
      />
    </FormField>
  );
};

export default Textarea;
